export const Hide = ({ state = true, children }) => {
    if (state) return null;
    return children;
}